<template lang="html">
  <section class="main_page">
    <transition class="content-fade">
      <v-container fluid class="pa-0">
        <v-row>
          <v-col class="home-hero__content-text">
            <v-card class="hero text-center" cover flat>
              <v-img src="../assets/bg_sp.jpg">
                <template #sources>
                  <source srcset="../assets/bg.webp" />
                  <source
                    media="(max-width: 480px)"
                    srcset="../assets/bg_sp.jpg"
                  />
                  <source srcset="../assets/bg.webp" type="image/webp" />
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
        <LinkSoftware />
        <p class="catch" style="font-size: 1.5em;">
          ◆2023/06/09 商品情報のページに限定版詳細と店舗特典を追加しました。
        </p>
      </v-container>
    </transition>
  </section>
</template>

<style scoped>
  @import "../styles/common/css/top.css";
  .v-img__picture {
    top: 30px;
  }
</style>
<script>
  import LinkSoftware from "./LinkSoftware.vue";

  export default {
    name: "App",
    components: {
      LinkSoftware,
    },
  };
</script>
